import { EChartsOption } from 'echarts';

import { ConnectionHistoryInput } from './connext-connection-history.component';

export const getStyleProp = (prop: string) =>
  window.getComputedStyle(document.querySelector('body') as any).getPropertyValue(prop);

const green_200 = getStyleProp('--green-200');
const grey_200 = getStyleProp('--grey-200');

export const getConnextConnectionIniGraph = (): EChartsOption => ({
  tooltip: {
    trigger: 'axis',
  },
  grid: {
    top: '3%',
    left: '3%',
    right: '3%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: {
    type: 'time',
    min: 0,
    max: 0,
    minorTick: {
      show: true,
    },
    minorSplitLine: {
      show: true,
    },
  },
  yAxis: {
    type: 'value',
    min: 0,
    max: 1,
    splitNumber: 1,
  },
  series: [
    {
      name: 'Reason of disconnection',
      type: 'line',
      step: 'middle',
      data: [],
      itemStyle: {
        color: green_200,
      },
    },
  ],
});

export const updateConnextConnectionGraph = (chartOption: EChartsOption, input: ConnectionHistoryInput): EChartsOption => {
  const data = input.historyConnections.map((item) => [item.timestamp, item.status]);
  const historyConnections = input.historyConnections;
  const disconnectReason = input.historyConnections.map((item) => item.disconnectReason?.split('_').join(' ').toLocaleLowerCase());

  return ({
    ...chartOption,
    tooltip: {
      trigger: 'axis',
      formatter: (params: any) => {
        let html = `<div class="text-center text-accent fx-col fx-center body-2">` +
          new Date(params[0].axisValue).toLocaleString() + '<br><table>';
        params.forEach((p: any, index: number) => {
          if (p.value[1] !== 1) {
            html += `<tr><td class="text-red body-3 text-uppercase text-center">Disconnected` + '</td></tr>';
            if (index === 0) {
              html += `<tr><td class="text-grey-400 body-3 text-center capitalize-first">` + disconnectReason[p.dataIndex] + '</td></tr>';
            }
          } else {
            if (index === 0) {
              html += `<tr><td class="text-green-500 body-3 text-uppercase text-center">Connected` + '</td></tr>';
              html += `<tr><td class="text-accent body-3 text-center">` + historyConnections[p.dataIndex].ipAddress + '</td></tr>';
            }
          }
        });
        html += '</table></div>';
        return html;
      },
    },
    xAxis: {
      type: 'time',
      min:input.dateFrom,
      max:input.dateTo,
      axisLabel: {
        color: grey_200,
        rotate: 45,
      },
    },
    series: [
      {
        name: "Reason of disconnection",
        type: "line",
        step: "middle",
        data,
        itemStyle: {
          color: green_200,
        },
      },
    ],
  });
};
